module.exports = __webpack_public_path__ + "img/info.2153506.png";